import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericInputDialogComponent } from './generic-input-dialog.component';
import { DevExtremeModule } from '../devextreme.module';

@NgModule({
   declarations: [
      GenericInputDialogComponent
   ],
   imports: [ CommonModule, DevExtremeModule ],
   exports: [
      GenericInputDialogComponent
   ],
   providers: [],
})
export class GenericInputDialogModule {}